export const FLIGHT_SEARCH_TAB = 0;
export const HOTEL_SEARCH_TAB = 1;
export const CAR_SEARCH_TAB = 2;
export const STATIC_PRODUCT_SEARCH_TAB = 3;
